import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getDownloadConfirmationParams = ({ downloadMeasurements }) => {
	return downloadMeasurements.measurementDownloadDialogParams;
};

const getDateSelection = ({ overview }) => {
	return overview.dateSelection;
};

const getSelectedAsset = ({ powertrainAssetDetails }) => {
	return powertrainAssetDetails.selectedAsset;
};

const getTrendKPIsLoadingStatus = ({ operationalParameters }) => {
	return operationalParameters?.availableKPIs?.trend?.loadingStatus;
};

const getMeasurementExportLoadingStatus = ({ downloadMeasurements }) => {
	return downloadMeasurements.measurementExport.loadingStatus;
};

const getMeasurementExportRawError = ({ downloadMeasurements }) => {
	return {
		loadingStatus: downloadMeasurements.measurementExport.loadingStatus,
		error: downloadMeasurements.measurementExport.error,
		errorCode: downloadMeasurements.measurementExport.error?.statusCode || downloadMeasurements.measurementExport.error?.response?.status
	};
};

const getMeasurementExportErrorData = createErrorDataSelector(getMeasurementExportRawError);

export const getModel = createSelector([
	getDownloadConfirmationParams,
	getDateSelection,
	getSelectedAsset,
	getTrendKPIsLoadingStatus,
	getMeasurementExportLoadingStatus,
	getMeasurementExportErrorData
],
	(
		measurementDownloadDialogParams,
		dateSelection,
		asset,
		trendKpisLoadingStatus,
		measurementExportLoadingStatus,
		measurementExportErrorData
	) => {
		return {
			measurementDownloadDialogParams,
			dateSelection,
			asset,
			trendKpisLoadingStatus,
			measurementExportLoadingStatus,
			measurementExportErrorData
		};
	});
